import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronRight, X } from "lucide-react";
import "./funcionalidadesEvento.scss";

// Modal de funcionalidades do evento. Hoje só existe a confirmação de presença,
// mas o formato de acordeão já acomoda as próximas sem redesenho.
export default function ModalFuncionalidades({
  aberto,
  valorInicial,
  onSalvar,
  onFechar,
}) {
  const [expandido, setExpandido] = useState(false);
  const [marcado, setMarcado] = useState(!!valorInicial);

  // Reabrir o modal sempre parte do valor que está no formulário, não do que
  // ficou da abertura anterior (o X descarta).
  useEffect(() => {
    if (aberto) {
      setMarcado(!!valorInicial);
      setExpandido(false);
    }
  }, [aberto, valorInicial]);

  if (!aberto) return null;

  return (
    <div className="func-modal-overlay" role="presentation" onClick={onFechar}>
      <div
        className="func-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Funcionalidades do evento"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="func-modal__close"
          onClick={onFechar}
          aria-label="Fechar"
        >
          <X size={16} />
        </button>

        <button
          type="button"
          className="func-modal__accordion"
          onClick={() => setExpandido((v) => !v)}
          aria-expanded={expandido}
        >
          {expandido ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
          <span>Confirmação de presença</span>
        </button>

        {expandido && (
          <label className="func-modal__opcao">
            <input
              type="checkbox"
              checked={marcado}
              onChange={(e) => setMarcado(e.target.checked)}
            />
            <span>Permitir que os alunos confirmem presença no evento</span>
          </label>
        )}

        <div className="func-modal__acoes">
          <button
            type="button"
            className="func-modal__salvar"
            onClick={() => onSalvar(marcado)}
          >
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
}
